import React from 'react';
import { Button, Modal } from '@app/components';
import { modalsSelectors } from '@app/store';
import { useAppSelector } from '@app/store/hooks';

interface Props {
  id: string;
  registerCode: string;
  close: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

// Déclarer une caisse disparue est IRRÉVERSIBLE : l'engine la ferme et
// constitue l'archive FINALE avec ce qu'il a reçu. Les pièces restées sur
// l'iPad sont perdues. La modale le dit avant le geste.
export const DeclareLostModal = ({ id, registerCode, close, onConfirm, isLoading }: Props) => {
  const modal = useAppSelector((state) => modalsSelectors.selectById(state, id));

  return (
    <Modal isOpen={!!modal?.isOpen}>
      <Modal.Title>Attention !</Modal.Title>
      <Modal.Subtitle>Déclarer la caisse {registerCode} disparue</Modal.Subtitle>
      <Modal.Message>
        Ce geste est irréversible. La caisse sera fermée définitivement et son archive fiscale finale sera constituée avec les pièces déjà répliquées.
        Les pièces qui n’auraient pas quitté l’iPad seront perdues. Ne faites ce geste que si l’iPad est réellement perdu, volé ou détruit.
      </Modal.Message>
      <Modal.Action>
        <Button title="Annuler" onPress={close} large />
        <Button title="Déclarer disparue" onPress={onConfirm} large bordered loading={isLoading} />
      </Modal.Action>
    </Modal>
  );
};
